import React from "react";
import { Link, useLocation } from "react-router-dom";
import FrontierMark from "@/components/FrontierMark";
import { useAuth } from "@/lib/auth";

const NAV = [
    { label: "Newsletter", href: "/#newsletter" },
    { label: "Podcast", href: "/#video" },
    { label: "Events", href: "/#events" },
    { label: "Sectors", href: "/#sectors" },
];

export default function Header({ showCoords = true }) {
    const { user } = useAuth();
    const location = useLocation();
    const isHome = location.pathname === "/";

    return (
        <header className="relative z-20" data-testid="site-header">
            <div className="max-w-[1440px] mx-auto px-6 md:px-10 pt-5">
                <div className="panel flex items-center justify-between px-5 py-3.5" data-testid="header-topbar">
                    <Link to="/" className="flex items-center gap-4" data-testid="brand-logo">
                        <FrontierMark size="md" />
                    </Link>

                    <nav className="hidden lg:flex items-center gap-6">
                        {NAV.map((item) =>
                            item.href.startsWith("/#") && isHome ? (
                                <a
                                    key={item.href}
                                    href={item.href}
                                    className="font-mono-tech text-[11px] tracking-[0.18em] uppercase text-[var(--ink-2)] hover:text-[var(--cobalt)] transition-colors"
                                    data-testid={`nav-${item.label.toLowerCase().replace(/[^a-z0-9]/g, "")}`}
                                >
                                    {item.label}
                                </a>
                            ) : (
                                <Link
                                    key={item.href}
                                    to={item.href.replace(/^\/#/, "/")}
                                    className="font-mono-tech text-[11px] tracking-[0.18em] uppercase text-[var(--ink-2)] hover:text-[var(--cobalt)] transition-colors"
                                    data-testid={`nav-${item.label.toLowerCase().replace(/[^a-z0-9]/g, "")}`}
                                >
                                    {item.label}
                                </Link>
                            )
                        )}
                    </nav>

                    <div className="flex items-center gap-4">
                        {user?.is_admin ? (
                            <Link to="/admin" className="btn-ghost btn-small" data-testid="header-admin-link">
                                Admin
                            </Link>
                        ) : null}
                    </div>
                </div>

                {showCoords ? (
                    <div className="panel-sub mt-2.5 grid grid-cols-2" data-testid="coords-strip">
                        <CoordCell k="LAT" v="40.7128°N" />
                        <CoordCell k="LONG" v="74.0060°W" last />
                    </div>
                ) : null}
            </div>
        </header>
    );
}

function CoordCell({ k, v, last = false }) {
    return (
        <div
            className="px-4 py-2.5 flex items-center justify-between gap-3"
            style={{
                borderRight: last ? "none" : "1px solid var(--rule-soft)",
            }}
        >
            <span className="overline">{k}</span>
            <span
                className="font-mono-tech text-[11.5px] tracking-[0.08em] font-semibold"
                style={{ color: "var(--cobalt)" }}
            >
                {v}
            </span>
        </div>
    );
}
